module.exports = __webpack_public_path__ + "static/img/logo-head.d86e3ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-head.png
// module id = u56i
// module chunks = 1